import { render } from "./NotFoundComponent.vue?vue&type=template&id=63ea4757"
const script = {}
script.render = render

export default script